import { useIntl } from "react-intl";

import { YesNoModal, YesNoModalProps } from "shared/components/YesNoModal";

export type UnclaimListConfirmationModalProps = Pick<
  YesNoModalProps,
  "isOpen" | "onClickYes" | "onClickNo"
>;

export function UnclaimListConfirmationModal({
  onClickYes,
  onClickNo,
  isOpen,
}: UnclaimListConfirmationModalProps) {
  const intl = useIntl();
  return (
    <YesNoModal
      isOpen={isOpen}
      onClickYes={onClickYes}
      onClickNo={onClickNo}
      title={intl.formatMessage({
        id: "components.unclaim-list-confirmation-modal.title",
      })}
      body={intl.formatMessage({
        id: "components.unclaim-list-confirmation-modal.body",
      })}
      yesLabel={intl.formatMessage({
        id: "components.unclaim-list-confirmation-modal.yes",
      })}
      noLabel={intl.formatMessage({
        id: "components.unclaim-list-confirmation-modal.no",
      })}
      isGrey
    />
  );
}
